import {useLingui} from '@lingui/react/macro'

import {getLocalizedFeedName} from '#/lib/strings/feed-names'
import {type FeedSourceInfo} from '#/state/queries/feed'
import {type RenderTabBarFnProps} from '#/view/com/pager/Pager'
import {TabBar} from '../pager/TabBar'
import {HomeHeaderLayout} from './HomeHeaderLayout'

export function HomeHeader(
  props: RenderTabBarFnProps & {
    testID?: string
    onPressSelected: () => void
    feeds: Pick<FeedSourceInfo, 'displayName' | 'uri'>[]
  },
) {
  const {feeds, onSelect} = props
  const {i18n} = useLingui()

  /*
   * Upstream appended an extra "Feeds" tab here whenever nothing but
   * Following was pinned, linking out to the feed-discovery screen. This
   * fork removed custom feeds entirely - Following and Discover are the
   * only two tabs and both are permanent - so that tab could only ever
   * appear when Discover was missing (see usePinnedFeedsInfos, which now
   * synthesizes it), and it routed to a surface the product no longer has.
   */
  const items = feeds.map(f => getLocalizedFeedName(f, i18n))

  return (
    <HomeHeaderLayout tabBarAnchor={props.tabBarAnchor}>
      <TabBar
        key={items.join(',')}
        onPressSelected={props.onPressSelected}
        selectedPage={props.selectedPage}
        onSelect={onSelect}
        testID={props.testID}
        items={items}
        dragProgress={props.dragProgress}
        dragState={props.dragState}
        transparent
      />
    </HomeHeaderLayout>
  )
}
